export default "__VITE_ASSET__4UBadhZ8__"